module.exports = __webpack_public_path__ + "static/sample_GREEN_PC-30d0ab11896b8efbb4ec275b3bed57b9.png";